import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { Observable } from 'rxjs';
import { AadhaarBasedAuthenticationService } from '../aadhaar/aadhaar.service';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService implements CanActivate {

   
  constructor(private router: Router, 
    private authenticationService: AuthenticationService,
    private aadhaarService: AadhaarBasedAuthenticationService
   ) {}

canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
   const isloggedIn = this.authenticationService.isLoggedIn ();
   
    if (!isloggedIn) {
      this.router.navigate (['/home/login']);
      return false;
    }

    if (state.url === "/verify-aadhaar") return true;

    const isAadhaarRequired = this.aadhaarService.isAadhaarRequired()
    const user = this.authenticationService.getUserDetails()

    console.log("isAadhaarRequired", isAadhaarRequired)
    console.log("user", user)

    if (isAadhaarRequired && !user?.isAadhaarVerified) {
      console.log("user.isAadhaarVerified", user?.isAadhaarVerified)
      console.log("rerouting to verify aadhaar")
      this.router.navigate(['/verify-aadhaar'])
      return false
    }
    return true;
  }
}
